function normalizePath(pathname = "") {
  const trimmed = String(pathname).replace(/\/+$/, "")
  return trimmed || "/"
}

export function getPathLanguage(pathname) {
  const normalizedPath = normalizePath(pathname)
  return normalizedPath === "/en" || normalizedPath.startsWith("/en/")
    ? "en"
    : null
}

export function stripEnglishPrefix(pathname) {
  const normalizedPath = normalizePath(pathname)
  return normalizedPath === "/en"
    ? "/"
    : normalizedPath.startsWith("/en/")
    ? normalizePath(normalizedPath.slice(3))
    : normalizedPath
}

export function getLocalizedPath(pathname, lang) {
  const basePath = stripEnglishPrefix(pathname)
  return lang === "en" ? (basePath === "/" ? "/en" : `/en${basePath}`) : basePath
}

export function normalizeRoutePath(pathname) {
  return normalizePath(pathname)
}
